import React from "react";

import { Heading } from "@bps/fluent-ui";
import { FieldDevice } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import {} from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { ClaimsFilter } from "./ClaimsFilter";
import { ClaimsTable } from "./ClaimsTable";

interface FieldDeviceClaimsProps {
  device: FieldDevice;
}

export const FieldDeviceClaims: React.FC<FieldDeviceClaimsProps> = ({
  device
}) => {
  return (
    <>
      <Heading variant="section-heading">Claims</Heading>

      <ClaimsFilter>
        {({ values }) => {
          return <ClaimsTable deviceId={device.id} filter={values} />;
        }}
      </ClaimsFilter>
    </>
  );
};
